module.exports = __webpack_public_path__ + "static/media/3-c.166763e8.png";